import script from "./selected-external-company.vue?vue&type=script&setup=true&lang=ts"
export * from "./selected-external-company.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__